import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`

html body {
  margin: 0;
	border: 0;
  width: 100%;
  height: 100%;
	padding: 0;
	font-size: 100%;
	vertical-align: baseline;
  font: 400 16px Roboto, sans-serif;
  background-color: ${(props) => props.theme.colors.primary};
}


h1, h2, h3, h4, h5, h6{
  margin-bottom: 0px;
}

header {
  display: flex;
  grid-column: 2/3;
  grid-row: 1/2;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  text-transform: uppercase;
  font-weight: 100;

  background-color: ${(props) => props.theme.colors.primary_light};
  padding: 5px 10px 5px 10px;
}

main{
  position: relative;
  border-left: 1px solid ${(props) => props.theme.colors.white};
  grid-column: 2/3;
  grid-row: 2/4;
  display: flex;
  overflow-x: auto;
}

img{
  border: 0px solid black;
}

input, select, textArea {
  font-size: 1rem;
  transition: border-color 0.2s ease;
  background: none;
  border: solid;
  border-width:1px;
  border-radius: 5px;
  border-color: ${props => props.theme.colors.background_primary};
  box-shadow: ${props => props.theme.box_shadow.box_shadow};
  max-width:400px;
  margin-left:2px;
  option:hover{
    color:red;
  }
}

button, .button {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  border: none;
  outline: none;
  padding: 10px 20px;
  color: ${props => props.theme.colors.black};
  font-size: ${props => props.theme.spacing.spacing_05};
  border-radius: ${props => props.theme.button.border_radius};
  box-shadow: ${props => props.theme.box_shadow.box_shadow};
  transition-duration: ${props => props.theme.button.transition_duration};
  :hover {
    color: ${props => props.theme.button.hover.color};
    background-color: ${props => props.theme.button.hover.background_color};
    box-shadow: ${props => props.theme.box_shadow.hover.box_shadow};
  }
  :focus{
      color: ${props => props.theme.button.hover.color};
    outline: ${props => props.theme.button.focus.outline};
    background-color: ${props => props.theme.button.focus.background_color};
  }
  }

table, .table{
  margin: 0px;
}

.fileInput{
  border: 0;
}
.filePreview{
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  overflow-wrap: break-word;
  gap: ${(props) => props.theme.spacing.spacing_04};

  label{
    flex: 1 1 120px;
  }
}

.clickable{
  cursor: pointer;
}

.clickableEffects {
  cursor: pointer;
  transition: filter 0.15s, transform 0.1s;
}

.clickableEffects:hover {
  filter: brightness(0.9) saturate(0.8);
}

.clickableEffects:active {
  filter: brightness(0.75) saturate(0.7);
  transform: scale(0.97);
}

.alert{
  text-align: center;
  padding: 20px;
  margin: 20px;
  font-size: ${(props) => props.theme.spacing.spacing_05};

}
.alert-error{
  color: ${(props) => props.theme.alert_error.color};
  border:   ${(props) => props.theme.alert_error.border};
  background-color: ${(props) => props.theme.alert_error.background_color};
}
.alert-warning{
  color: ${(props) => props.theme.alert_warning.color};
  border: ${(props) => props.theme.alert_warning.border};
  background-color: ${(props) => props.theme.alert_warning.background_color};
}
.alert-info{
  color: ${(props) => props.theme.alert_info.color};
  border: ${(props) => props.theme.alert_info.border};
  background-color: ${(props) => props.theme.alert_info.background_color};
}

.alert-success{
  color: ${(props) => props.theme.alert_success.color};
  border: ${(props) => props.theme.alert_success.border};
  background-color: ${(props) => props.theme.alert_success.background_color};
}

.panel{
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.primary};
  padding: ${(props) => props.theme.spacing.spacing_05};
  box-shadow: ${props => props.theme.button.box_shadow};
  :hover {
    background-color: ${props => props.theme.button.hover.white};
    box-shadow: ${props => props.theme.button.hover.box_shadow};
  }
  :focus{
    background-color: ${props => props.theme.button.focus.white};
    outline: ${props => props.theme.button.focus.outline};
  }
}

.boxShadow{
  box-shadow: ${props => props.theme.box_shadow.box_shadow};
  transition: ${props => props.theme.box_shadow.transition_duration};
  :hover {
    box-shadow: ${props => props.theme.box_shadow.hover.box_shadow};
  }
}

.glass{
  background: rgba( 255, 255, 255, 0.25 );
  box-shadow: 0 2px 2px 0 rgba( 31, 38, 135, 0.37 );
  backdrop-filter: blur( 5px );
  -webkit-backdrop-filter: blur( 5px );
  border: 1px solid rgba( 255, 255, 255, 0.18 );
}

.table-title{
  display: flex;
  padding: 5px 10px 5px 10px;
  justify-content: space-between;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.secondary};

  button{
    background-color: ${props => props.theme.colors.complementary};
    color: ${props => props.theme.colors.white};
  }
}

.default-page{
  width: 100%;
  height: 100%;
  overflow:scroll;
  border: 1px solid ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primary_light};
  padding-left: 10px;
}

.default-main{
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.spacing_04};
  background-color: transparent;
  border:0px;
}

.return-button{
  margin-top: 20px;
  margin-bottom: 20px;
}

.main-table{
  width: 100%;
  border-left: none;
}

.main-table thead {
  color: ${props => props.theme.colors.white};
  height: ${props => props.theme.spacing.spacing_09};
  background-color: ${props => props.theme.colors.secondary};
}

.main-table td, .main-table th{
  vertical-align: middle !important;
  border-left: none;
  padding-left:${props => props.theme.spacing.spacing_03};
}

.main-table tbody tr{
  height: ${props => props.theme.spacing.spacing_09};
  border-left: none;
  cursor: pointer;
}

.action{
  display: flex;
  justify-content: center;
}

.action > button{
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.black};
  border:none;
  background-color: transparent;
  margin:0px;
  margin-right:2px;
  margin-left:2px;
  :hover{
    background-color: transparent;
  }
  :focus{
    background-color: transparent;
  }
  .icon{
    margin:0px;
  }
}

.main-form{
  display:grid;
  grid-template-columns: max-content max-content;
  grid-gap:5px;

  #header{
    margin-bottom: ${props => props.theme.spacing.spacing_04};
  }
}

.main-form h2{
  font-size: 24px;
  font-weight: 500;
  padding: 8px 0px 8px 0px;
  text-align: center;
  border-bottom: 1px solid ${props => props.theme.colors.primary};
  grid-column: 1/3;
  margin-bottom: ${props => props.theme.spacing.spacing_04};
}

.main-form > div {
  grid-column: 1/3;
  display: contents;
}

.main-form > div label{
  grid-column: 1/2;
}

.main-form .labelInput{
  grid-column: 2/3;
}
.checkbox {
  display:flex;
  justify-content:flex-end;
  align-items:center;
  input{
    width:30px;
    height:30px;
  }
}

.progress{
  width: 100%;
  margin: 0px;
}

.currency{
  color: ${props => props.theme.colors.green};
  white-space: nowrap;
}

.progress > .progress-bar{
  margin-bottom: 0px;
  margin-top: 0px;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #a2a2a2;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`;
